import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const Fields = ({provider = {}, prefix = '', multiplePanes = true, children}) => {
  return (
    <Panes
      entity={provider}
      prefix={prefix}
      panes={[
        {
          title: 'Review Provider Details',
          fields: [
            <TextField
              name="name"
              prefix={prefix}
              label="Name"
              rules={{required: 'Please enter a name'}}
            />,
            <TextField
              name="url"
              prefix={prefix}
              label="Link"
              rules={{required: 'Please enter a link which can be used to review with this provider'}}
            />
          ]
        }
      ]}
      title={multiplePanes ? null : 'Review Provider Details'}
    >{children}</Panes>
  );
};

export default Fields;
